module.exports = __webpack_public_path__ + "static/media/rainbow.6a6f671f.svg";